import Cookies from 'universal-cookie';

import CONFIG from './../SYSTEM/Config.js'
import { sendPostRequest } from "./../SYSTEM/Request.js"

var initState = {
	APIKEY: false,
	USER: false,
	OPEN_LOGIN: false,
	OPEN_PARTNERSHIP: false,
	OPEN_COMMENTS: false,
	OPEN_MARKETING: false,
	SET_OWN_PRICE: false,
	PENDING_ORDERS: 0,
	FETCH_PENDING_ORDERS: false,
	SHOW_ELEMENTS: true,
	TO_ORDER_PRODUCTS: {},
	UNREAD_MESSAGES: 0,
	PRINTER_IP: false
};

const cookies = new Cookies();

var reducer = function (state = initState, action) {
	switch (action.type) {
		case 'SET_PRINTER_IP':
			localStorage.setItem('PRINTER_IP', action.data);

			return {
				...state,
				PRINTER_IP: action.data
			}

		case 'TOGGLE_PRODUCT_IN_TO_ORDER_PRODUCTS': {
			let NEW_TO_ORDER_PRODUCTS = Object.assign({}, { ...state.TO_ORDER_PRODUCTS })
			if (typeof NEW_TO_ORDER_PRODUCTS[action.data.id] == "undefined") {

				NEW_TO_ORDER_PRODUCTS[action.data.id] = action.data
			} else {
				delete NEW_TO_ORDER_PRODUCTS[action.data.id]
			}

			return {
				...state,
				TO_ORDER_PRODUCTS: NEW_TO_ORDER_PRODUCTS
			}
		}

		case 'SET_PRODUCTS_TO_ORDER': {
			return {
				...state,
				TO_ORDER_PRODUCTS: action.data
			}
		}

		case 'DISABLE_ELEMENTS': {
			return {
				...state,
				SHOW_ELEMENTS: action.data
			}
		}

		case 'FETCH_PENDING_ORDERS': {
			return {
				...state,
				FETCH_PENDING_ORDERS: action.data
			}
		}

		case 'PENDING_ORDERS': {
			return {
				...state,
				PENDING_ORDERS: action.data
			}
		}

		case 'UNREAD_MESSAGES': {
			return {
				...state,
				UNREAD_MESSAGES: action.data
			}
		}

		case 'SET_OWN_PRICE': {
			return {
				...state,
				SET_OWN_PRICE: action.data
			}
		}

		case 'OPEN_MARKETING': {
			return {
				...state,
				OPEN_MARKETING: action.data
			}
		}

		case 'OPEN_COMMENTS': {
			return {
				...state,
				OPEN_COMMENTS: action.data
			}
		}

		case 'OPEN_LOGIN': {
			return {
				...state,
				OPEN_LOGIN: action.data
			}
		}

		case 'OPEN_PARTNERSHIP': {
			return {
				...state,
				OPEN_PARTNERSHIP: action.data
			}
		}

		case 'DO_AUTH':
			cookies.set(CONFIG.COOKIE_TITLE, action.data[CONFIG.COOKIE_TITLE], { path: '/', time: action.data.time });
			return {
				...state,
				USER: action.data
			}

		case 'DO_LOG_OUT':
			cookies.set(CONFIG.COOKIE_TITLE, false, { path: '/', time: -1 });
			return {
				...state,
				USER: false
			}

		default:
			return state;
	}
}

export default reducer;